<script setup lang="ts">
import { computed, toRefs } from 'vue';
import { storeToRefs } from 'pinia';
import { useReviewReportStore } from '@/store';

const reviewReportStore = useReviewReportStore();
const { track } = storeToRefs(reviewReportStore);

interface Props {
  title: string;
  tooltip: string;
  icon: string;
  total: number;
  color: string;
}

const props = withDefaults(defineProps<Props>(), {
  title: '',
  tooltip: '',
  icon: 'calendar_today',
  total: 0,
  color: 'blue',
});

const { title, tooltip, icon, total, color } = toRefs(props);

const formatTotal = computed(() => new Intl.NumberFormat().format(total.value));
</script>

<template>
  <div class="flex mb-2">
    <Icon :name="icon" :class="`text-color-${color} text-4xl p-2 bg-${color}-light border-round align-self-start`" />
    <div class="mx-3">
      <h3 class="text-color-secondary text-base">{{ title }}</h3>
      <Skeleton v-if="track.loading" height="3rem" class="mt-1" />
      <span v-else :class="`text-color-${color}-dark text-5xl font-bold`" v-text="formatTotal" />
    </div>
    <Icon v-tooltip.bottom="`${tooltip}`" name="info" class="text-gray-400 text-base cursor-pointer align-self-start" />
  </div>
</template>
